import { ErrorBoundary } from '@sentry/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedRadarTemplateAtom } from '@/atoms/radar';
import { openShareModalAtom } from '@/atoms/userConfigs';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { hasFullAccessPermissions } from '@/utils/userConfigs';

const RadarTemplateShareMenuOptionBase = ({ onClick, isDisabled }: { onClick?: () => void; isDisabled?: boolean }) => {
  const { t } = useTranslation('general');

  return <MenuItemWithIcon icon="Forward" onClick={onClick} text={t('share')} disabled={isDisabled} />;
};

const RadarTemplateShareMenuOptionWithData = () => {
  const selectedTemplate = useAtomValue(selectedRadarTemplateAtom);

  const openShareModal = useSetAtom(openShareModalAtom);

  if (!selectedTemplate) {
    throw new Error('Unable to find selected radar template');
  }

  const onClick = () => openShareModal(selectedTemplate.configId);

  return (
    <RadarTemplateShareMenuOptionBase
      onClick={onClick}
      isDisabled={!hasFullAccessPermissions(selectedTemplate.permission)}
    />
  );
};

export const RadarTemplateShareMenuOption = () => (
  <ErrorBoundary fallback={<RadarTemplateShareMenuOptionBase isDisabled />}>
    <Suspense fallback={<RadarTemplateShareMenuOptionBase isDisabled />}>
      <RadarTemplateShareMenuOptionWithData />
    </Suspense>
  </ErrorBoundary>
);
